import { ff } from '@atlassian/jira-feature-flagging';
import {
	CSV,
	JIRA_BUSINESS,
	JIRA_SOFTWARE,
	SourceItemKeys,
} from '../../common/constants/import-type';
import { SourceType, getSourceItemMap } from '../../common/constants/source-items';
import { API_FLOW, CSV_FLOW, type ImporterSourceItem } from '../../common/types';
import type { FormatMessage, ImporterSource } from './types';

export const transformData = (
	data: ImporterSource[],
	formatMessage: FormatMessage,
	isSiteAdmin: boolean,
	isAdmin: boolean,
	hasJSWLicense: boolean,
): ImporterSourceItem[] => {
	const sourceItemMap = getSourceItemMap(formatMessage);
	const result: ImporterSourceItem[] = data.map((item) =>
		SourceItemKeys.has(item.serviceName)
			? {
					...sourceItemMap[item.serviceName],
					supportedFlow: item.apiProducts.length > 0 ? API_FLOW : CSV_FLOW,
					[CSV_FLOW]: item.csvProducts,
					[API_FLOW]: item.apiProducts,
				}
			: {
					...sourceItemMap[CSV],
					key: item.serviceName,
					name: item.serviceName,
					supportedFlow: CSV_FLOW,
					[CSV_FLOW]: item.csvProducts,
					[API_FLOW]: item.apiProducts,
					sourceType: SourceType.THIRD_PARTY,
				},
	);

	// add jira products if has jsw license
	if (isSiteAdmin && hasJSWLicense) {
		result.push({
			...sourceItemMap[JIRA_SOFTWARE],
			supportedFlow: API_FLOW,
			[CSV_FLOW]: [],
			[API_FLOW]: [
				{
					productType: 'business',
					isRecommended: false,
					projectStyles: [],
				},
			],
		});

		if (ff('jira-business-to-software-project-imports')) {
			result.push({
				...sourceItemMap[JIRA_BUSINESS],
				supportedFlow: API_FLOW,
				[CSV_FLOW]: [],
				[API_FLOW]: [
					{
						productType: 'software',
						isRecommended: false,
						projectStyles: [],
					},
				],
			});
		}
	}

	// add csv item
	if (isSiteAdmin || (isAdmin && ff('enable-product-admin-for-x2c-migration_zmlsv'))) {
		result.push({
			...sourceItemMap[CSV],
			supportedFlow: CSV_FLOW,
			[CSV_FLOW]: [
				{
					productType: 'business',
					isRecommended: false,
					projectStyles: ['TEAM_MANAGED_PROJECT', 'COMPANY_MANAGED_PROJECT'],
				},
				{
					productType: 'software',
					isRecommended: false,
					projectStyles: ['TEAM_MANAGED_PROJECT', 'COMPANY_MANAGED_PROJECT'],
				},
			],
			[API_FLOW]: [],
		});
	} else {
		result.push({
			...sourceItemMap[CSV],
			supportedFlow: CSV_FLOW,
			[CSV_FLOW]: [
				{
					productType: 'business',
					isRecommended: false,
					projectStyles: ['TEAM_MANAGED_PROJECT'],
				},
			],
			[API_FLOW]: [],
		});
	}

	return result;
};
